import { Chip, Typography } from '@mui/material';

import AdaptiveChipList from 'ui/AdaptiveChipList/AdaptiveChipList';
import { DashboardCoreInfoT } from 'business/definitions';
import Flex from 'ui/Flex/Flex';
import { Link } from 'react-router-dom';
import React from 'react';
import { useTranslation } from 'react-i18next';

type UserGroupSharedDashboardsProps = {
    dashboards: DashboardCoreInfoT[];
};

const GroupSharedDashboardsChips = (dashboards: DashboardCoreInfoT[]) =>
    dashboards.map((dashboard) => (
        <Link
            key={`group-shared-dashboard-${dashboard.slug}`}
            to={`/dashboard/${dashboard.slug}`}
            target="_blank"
        >
            <Chip
                label={dashboard.title}
                size="small"
                sx={{ width: 'fit-content' }}
                variant="outlined"
                color="primary"
                clickable
            />
        </Link>
    ));

const UserGroupSharedDashboards = ({
    dashboards,
}: UserGroupSharedDashboardsProps): JSX.Element => {
    const { t } = useTranslation();

    return (
        <Flex direction="column" sx={{ gap: 2, p: 1 }}>
            <Typography variant="body1SemiBold">
                {t('adminSpace.editUserGroup.dashboardsSection')}
            </Typography>
            {dashboards.length === 0 ? (
                <Typography variant="body2">
                    {t('adminSpace.editUserGroup.noSharedDashboards')}
                </Typography>
            ) : (
                <AdaptiveChipList
                    defaultMaxHeight="88px" // It represents the height of 3 chips + a gap of 8px between them
                    chipsListLength={dashboards.length}
                >
                    {GroupSharedDashboardsChips(dashboards)}
                </AdaptiveChipList>
            )}
        </Flex>
    );
};

export default UserGroupSharedDashboards;
